import dayjs from 'dayjs'
import tz from 'dayjs/plugin/timezone.js'
import utc from 'dayjs/plugin/utc.js'

dayjs.extend(utc)
dayjs.extend(tz)

export const seconds = (v: number) => {
  return v * 1000
}

export const minutes = (v: number) => {
  return seconds(v) * 60
}

export const hours = (v: number) => {
  return minutes(v) * 60
}

export const time = {
  seconds,
  minutes,
  hours,
}
